module.exports = __webpack_public_path__ + "assets/img/2.34d505aa.png";